// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"styles_carouselContainer__nnXiz","pinCount":"styles_pinCount__DpXws","carouselSlide":"styles_carouselSlide__QwpkR"};